export const number = {
  is_custom: {
    own: 'Own number',
    rent: 'For rent'
  },
  type: {
    local: 'Local',
    toll_free: 'Toll free',
    mobile: 'Mobile',
    national: 'National'
  },

  status: {
    stand_by: 'Not active',
    active: 'Active',
    deactivated: 'Deactivated',
    canceled: 'Canceled',
    on_deactivation: 'On deactivation'
  },

  is_spam: {
    yes: 'Spam',
    no: 'Check'
  },

  state: {
    direction_to_pbx_error: 'PBX referral error',
    direction_to_pbx_pending: 'Sent to the PBX',
    direction_to_pbx_success: 'Aimed at PBX',
    direction_to_number_verification: 'Aimed to verification'
  },

  computed_confirmation_type: {
    support: 'Contact support',
    required_documents: 'Documents required',
    need_verification: 'Documents on moderation',
    allow_buying: 'Reserve'
  },

  field: {
    number: 'Number',
    country: 'Country',
    region: 'Region',
    type: 'Type',
    purchased_at: 'Purchased at',
    activated_at: 'Activated at',
    is_spam: 'Is spam',
    destinations: 'Destinations',
    connection_cost: 'Connection cost',
    subscription_fee: 'Subscription fee',
    minutes_cost: 'Cost per minute',
    allow_sms: 'SMS',
    state: 'Is used',
    deactivated_at: 'Deactivated at',
    capabilities: 'Capabilities',
    current_status: 'Current status',
  },

  action: {
    deactivate: 'Deactivate',
    connect_pbx: 'Send to PBX',
    stats: 'Statistics'
  },

  modal: {
    deactivate: {
      content: 'Are you sure you want to deactivate the phone number {number}?'
    },

    connect_pbx: {
      content:
        '<p>Do you really want to send the telephone number {number} to the PBX?</p> After connecting, the number will be available within a few hours.'
    },

    buy: {
      content:
        '<p>Do you really want to reserve phone number {number}?<br> Connection cost - {connection_cost}, <br> subscription fee - {subscription_fee}.</p>'
    },

    required_documents: {
      content: '<p>Upload documents to purchase {number} phone number.</p>'
    },

    add_custom: {
      title: 'Add your number',
      field: {
        code: {
          title: 'Code'
        }
      },
      button: {
        send: 'Send',
        check: 'Check',
        save: 'Save'
      },
      error: {
        duplicate: 'Number already exists'
      }
    }
  },
  days_until_payment: '0 day before payment | {count} day before payment | {count} days before payment',

  badge: {
    total_active: 'Active numbers',
    total: 'Total numbers',
    fee: 'Subscription fee'
  },

  tooltips: {
    fee:
      "Total cost per subscription fee for all currently active numbers.",
    all_number_period:
      'Includes numbers in any status whose activation date was no later than the end of the period.',
    cost_period:
      'The sum of all subscription fee payment transactions whose date is included in the period rank.',
    average_period: 'The sum of subscription fee payments divided by the number of debits.'
  }
};
